export default __webpack_public_path__ + "static/media/9410 - Niftynaut.b67f0ec2.jpeg";